import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams
} from "react-router-dom"
import { ChevronLeft, Download } from "lucide-react"

import Invoice from "../../invoice"
import If from "../../if"
import { LightBtn, LinkBtn } from "../../buttons"
import { handleInvoiceDownload } from "../../../utils/handleInvoiceDownload"
import { useAppDispatch, useInMobileView } from "../../../hooks"
import { pushToast } from "../../../../redux/slices/notifications"
import { Brand, LoanOfficer } from "../../../../types"
import { useState } from "react"

interface OutletContext {
  profile: LoanOfficer
  brand: Brand
}

const BankInvoice = () => {
  const inMobileView = useInMobileView()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { _id = "" } = useParams<{ _id: string }>()
  const { brand } = useOutletContext<OutletContext>()
  const { usage: current } = location.state || {}

  const [isDownloading, setIsDownloading] = useState(false)

  const handleBack = () => {
    navigate("/account/billing")
  }

  const handleDownload = async () => {
    if (!current?.org_id && !_id) {
      dispatch(
        pushToast({
          msg: "Failed to download invoice",
          timeout: 3000
        })
      )
      return
    }

    setIsDownloading(true)
    const success = await handleInvoiceDownload(current.org_id, _id)
    if (!success) {
      dispatch(
        pushToast({
          msg: "Failed to download invoice",
          timeout: 3000
        })
      )
    }
    setIsDownloading(false)
  }

  if (!current) return null

  return (
    <div className="p-6">
      <div className="flex items-center justify-between">
        <LightBtn onClick={handleBack} text="base" size="sm">
          <ChevronLeft size={16} />
          &nbsp;
          <span className="inline-block px-1">Back</span>
        </LightBtn>

        <LinkBtn
          disabled={isDownloading}
          theme="alt"
          text="base"
          paddingOff
          onClick={handleDownload}
        >
          <If
            isLoading={isDownloading}
            loaderSize={4}
            loaderClassName="!p-0"
            condition={!isDownloading}
            then={<Download size={20} />}
          />

          {!inMobileView && <span className="ml-2">Download Invoice</span>}
        </LinkBtn>
      </div>
      <Invoice
        className="mt-8"
        companyName={brand?.name ?? ""}
        invoiceTimestamp={current.timestamp}
        usage={current.details}
      />
    </div>
  )
}

export default BankInvoice
